import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const NotificationSettingsForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const NotificationSettingsList = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  padding: 0,
  margin: 0,
}));

export const TextAndSwitchContainer = styled('label')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  marginRight: '-32px', // Counteracts the switch's margin right, which usually makes room for a label
}));

export const GroupedNotificationItem = styled('li')(({ theme }) => ({
  padding: theme.spacing(2, 0),
}));

export const NotificationGroupHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const NotificationGroupContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  flex: 1,
  minWidth: 0, // Allows text to wrap properly
}));

export const StyledButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
}));

// Styled Typography components with theme colors
export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.palette.text.primary,
}));

export const StyledDescriptionTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.footNoteRegular,
  color: theme.colors.gray,
}));

export const StyledButtonTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.palette.text.primary,
}));

// Section header styling - centered and distinct from notification group titles
export const StyledSectionHeaderTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodyEmphasized,
  padding: theme.spacing(2, 0),
  borderBottom: `1px solid ${theme.colors.grayDividerColor}`,
  marginBottom: theme.spacing(1),
}));
